import { Skeleton } from '@/entities/avail/components/common/Skeleton'

export function ContentSkeleton() {
  return (
    <div className="space-y-6 p-4 ">
      {/* Header Skeleton */}
      <div className="relative rounded flex flex-col bg-grey-400">
        <div className="space-y-4 p-4">
          <Skeleton className="h-7 w-auto max-w-[350px] rounded " />
          {/* Title 1 */}
          <Skeleton className="h-5 w-auto max-w-[400px] rounded" />
          {/* Title 2 */}
        </div>
        <div className="space-y-4 ">
          {/* Div with inputs and buttons */}
          <div className="flex flex-wrap gap-4 p-4 shadow-md rounded w-11/12  mx-auto lg:justify-start sm:justify-center md:justify-center xs:justify-center bg-grey-400 ">
            {/* Destination */}
            <Skeleton className="h-10 rounded lg:w-1/4 sm:w-full xs:w-full" />
            {/* Sale point */}
            <Skeleton className="h-10 rounded lg:w-1/4 sm:w-full xs:w-full" />
            {/* Checkin chekout */}
            <Skeleton className="h-10 rounded lg:w-1/4 sm:w-full xs:w-full" />
            {/* Filters */}
            <Skeleton className="h-10 rounded lg:w-20  sm:w-full xs:w-full flex-grow-0" />
            {/* Clean Filters */}
            <Skeleton className="h-10 rounded lg:w-20  sm:w-24 xs:w-24  md:w-24 flex-grow-0" />
            {/* Search */}
            <Skeleton className="h-10 rounded lg:w-20  sm:w-full xs:w-full flex-grow-0" />

            {/* Map (button) on the bottom line */}
            <Skeleton className="h-10 lg:w-60 flex-grow-0 sm:w-full xs:w-full" />
          </div>
        </div>
      </div>

      {/* Form Skeleton */}
    </div>
  )
}

// Skeleton para o layout completo (usado no Suspense principal)
export function LayoutSkeleton() {
  return (
    <main className="bg-white flex h-screen overflow-hidden p-2">
      {/* Sidebar skeleton */}
      <div className=" bg-grey-200 h-full w-64 shrink-0 flex flex-col">
        <div className="h-full rounded-lg bg-gray-100 animate-pulse flex-1 flex flex-col">
          {/* Top buttons */}
          <div className="h-16 flex w-full justify-between border-b  px-4 py-3">
            <Skeleton className="h-8 w-8" />
            <Skeleton className="h-8 w-32" />
            <Skeleton className="h-8 w-8" />
          </div>
          {/* Back to agency */}

          <Skeleton className="h-8 w-full" />
          {/* Bottom buttons */}
          <div className="h-48 flex flex-col gap-2 w-full justify-between border-b px-4 py-3 mt-auto">
            <Skeleton className="h-8 w-36" />
            <Skeleton className="h-8 w-full" />
            <Skeleton className="h-8 w-full" />
            <Skeleton className="h-2 w-40" />
          </div>
        </div>
      </div>

      {/* Content area skeleton */}
      <div className="w-full pb-20 mx-2 overflow-y-auto">
        <ContentSkeleton />
      </div>
    </main>
  )
}
